module.exports = __webpack_public_path__ + "img/CompScope_Space_04.2da1cd43.png";